import { TFunction } from '@lyearn/i18n';

export const FONT_COLORS = (t: TFunction) => [
  {
    label: t('Lygo:Default'),
    hexValue: '#000000',
  },
  {
    label: t('Lygo:Grey'),
    hexValue: '#888888',
  },
  {
    label: t('Lygo:Blue'),
    hexValue: '#2D65CB',
  },
  {
    label: t('Lygo:Orange'),
    hexValue: '#E17144',
  },
  {
    label: t('Lygo:Yellow'),
    hexValue: '#F6C944',
  },
  {
    label: t('Lygo:Purple'),
    hexValue: '#7B57ED',
  },
  {
    label: t('Lygo:Red'),
    hexValue: '#C9404C',
  },
];

export const BACKGROUND_COLORS = (t: TFunction) => [
  {
    label: t('Lygo:NoBackground'),
    hexValue: 'transparent',
  },
  {
    label: t('Lygo:LightYellow'),
    hexValue: '#FEF8A7',
  },

  {
    label: t('Lygo:LightGreen'),
    hexValue: '#D5FDAF',
  },
  {
    label: t('Lygo:LightBlue'),
    hexValue: '#BEFDFC',
  },
  {
    label: t('Lygo:LightRed'),
    hexValue: '#F8CDCC',
  },
  {
    label: t('Lygo:LightGray'),
    hexValue: '#DCDFE2',
  },
  {
    label: t('Lygo:LightPurple'),
    hexValue: '#DECFFC',
  },
];
